import confetti from "canvas-confetti";

const COLORS = ["#FF3366", "#00F0FF", "#FFD166", "#06D6A0", "#A855F7", "#EC4899"];

export function fireCelebration(big = false) {
  const burst = (opts) =>
    confetti({
      colors: COLORS,
      shapes: ["star", "circle"],
      scalar: 1.2,
      ...opts,
    });

  burst({ particleCount: big ? 120 : 60, spread: 70, origin: { y: 0.6 } });
  setTimeout(
    () => burst({ particleCount: big ? 80 : 40, angle: 60, spread: 55, origin: { x: 0 } }),
    150
  );
  setTimeout(
    () => burst({ particleCount: big ? 80 : 40, angle: 120, spread: 55, origin: { x: 1 } }),
    150
  );
  if (big) {
    setTimeout(
      () => burst({ particleCount: 100, spread: 100, startVelocity: 45, origin: { y: 0.5 } }),
      400
    );
  }
}

// Simple synthesized "whoosh + chime" using Web Audio API.
let audioCtx = null;
export function playChime(muted) {
  if (muted) return;
  try {
    audioCtx = audioCtx || new (window.AudioContext || window.webkitAudioContext)();
    const ctx = audioCtx;
    const notes = [523.25, 659.25, 783.99, 1046.5];
    notes.forEach((freq, i) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = "triangle";
      osc.frequency.value = freq;
      const t = ctx.currentTime + i * 0.09;
      gain.gain.setValueAtTime(0.0001, t);
      gain.gain.exponentialRampToValueAtTime(0.25, t + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.0001, t + 0.35);
      osc.connect(gain);
      gain.connect(ctx.destination);
      osc.start(t);
      osc.stop(t + 0.4);
    });
  } catch {}
}
